import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import React, { FC, useState } from 'react';
import { ReactComponent as StarIcon } from 'assets/icons/star-icon.svg';
import LocalModal from 'components/base/local-modal';
import LocalTextArea from 'components/base/local-text-area';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import useDashboardContext from 'contexts/dashboard.context';
import { handleApiError } from 'utils/functions';

type FeedbackModalProps = {
  show: boolean;
  onClose: () => void;
};

const ratings = ['1', '2', '3', '4', '5'];

const FeedbackModal: FC<FeedbackModalProps> = ({ show, onClose }) => {
  const [selectedRate, setSelectedRate] = useState('');
  const [optionalNote, setOptionalNote] = useState('');
  const [loading, setLoading] = useState(false);
  const { activeCompany } = useDashboardContext();
  const companyId = activeCompany?.id;

  const handleRate = (rate: string) => {
    setSelectedRate(rate);
  };

  const handleClose = () => {
    setSelectedRate('');
    setOptionalNote('');
    onClose();
  };
  const feebackRating = async () => {
    if (!companyId) return;

    const data = {
      company_id: companyId,
      note: optionalNote,
      rating: selectedRate
    };

    try {
      setLoading(true);
      const res = await apiService.post('member/send-feedback', { data });
      if (res) {
        toast(<ToastMessage type='success' message='we appreciate your feedback' />);
        setSelectedRate('');
        setOptionalNote('');
        onClose();
      }
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LocalModal
      isOpen={show}
      onRequestClose={handleClose}
      title='We appreciate your feedback'
      contentClassName=' sm:!max-w-[400px]'>
      <div>
        <h2 className='text-sm font-semibold mb-2 text-[#2E3031]'>Drop your rating</h2>
        <div className='flex w-full'>
          {ratings.map((rate, index) => (
            <div
              onClick={() => handleRate(rate)}
              key={index}
              className={`flex items-center justify-center bg-[#FAFAFA] border p-3 gap-1 w-full cursor-pointer 
                ${rate === '1' ? 'rounded-l-md ' : rate === '5' ? 'rounded-r-md' : ''}
                ${
                  selectedRate === rate
                    ? 'border-[#E60A2B] bg-[#FEF0F2] border-solid'
                    : 'border-[#E9EAEC]'
                }`}>
              <p>{rate}</p>
              <StarIcon />
            </div>
          ))}
        </div>
        <div>
          <div className='text-sm font-medium flex gap-1 mt-5 mb-2'>
            <p className='text-[#2E3031]'>Add a note</p>
            <p className='text-[#6F7376]'>(Optional)</p>
          </div>
          <LocalTextArea
            placeholder='What do you like about FoodCourt Business'
            className='text-sm bg-[#FAFAFA] border-x-0 border-t-0 rounded-none h-[135px]'
            value={optionalNote}
            onChange={(e) => setOptionalNote(e.target.value)}
          />
        </div>
        <div className='mt-5 flex justify-end'>
          <Button
            color='primary'
            variant='block'
            className='w-[139px] h-[41px]'
            loading={loading}
            disabled={!selectedRate}
            onClick={feebackRating}>
            Confirm
          </Button>
        </div>
      </div>
    </LocalModal>
  );
};

export default FeedbackModal;
